



$(document).ready(function() {
    $('.panel-heading').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('panel-heading--active');
        $(this).next('.panel-collapse').slideToggle().toggleClass('panel-collapse--active');
    });
});

